import { Link } from "react-router-dom";
import styles from "./cta.module.css";

export default function CTASection() {
  return (
    <section className={styles.cta}>
      <div className={styles.container}>
        <h2 className={styles.title}>Ready to Level Up?</h2>
        <p className={styles.subtitle}>
          Join thousands of gamers who've already switched to fair pricing
        </p>

        <Link to={"/"} className={styles.buttons}>
          <button className={styles.primaryBtn}>
            Start Shopping Now
            <span className={styles.arrow}>→</span>
          </button>
        </Link>

        <div className={styles.footer}>
          <p>With Each Phase, Destiny Respawns. 🌙</p>
        </div>
      </div>
    </section>
  );
}
